export default class ConfigBuilder
{
    constructor(element)
    {
        this.element = element;
    }

    get config()
    {
        let config = {
            "wait_for_scripts": true,
            "escape_to_close": true,
            "modifiers": [],
        };

        if (this.crossTransition) {
            config.cross_transition = true;
        }

        if (this.transition) {
            config.transition = this.transition;
        }

        if (this.modifiers) {
            config.modifiers = this.modifiers.split(',');
        }
        if (this.method) {
            config.method = this.method;
        }

        if (this.callback) {
            config.callback = this.callback;
        }

        if (this.data) {
            config.data = this.data;
        }

        if (this.stack) {
            config.stack = true;
        }

        if (this.loading) {
            config.loading = this.loading;
        }

        if (this.loadingTemplate) {
            config.loading_template = this.loadingTemplate;
        }

        if (this.closeTemplate) {
            config.close_template = this.closeTemplate;
        }

        return config;
    }

    get crossTransition()
    {
        if (this.element.hasAttribute('data-cross-transition')) {
            return true;
        }

        return false;
    }

    get modifiers()
    {
        if (this.element.hasAttribute('data-modifiers')) {
            return this.element.getAttribute('data-modifiers');
        }

        return null;
    }

    get method()
    {
        if (this.element.tagName == 'FORM' && this.element.hasAttribute('method')) {
            return this.element.getAttribute('method').toUpperCase();
        }

        if (this.element.hasAttribute('data-method')) {
            return this.element.getAttribute('data-method');
        }

        return null;
    }

    get data()
    {
        if (this.element.hasAttribute('data-data')) {
            return this.element.getAttribute('data-data');
        }

        return null;
    }

    get stack()
    {
        return this.element.hasAttribute('data-stack');
    }

    get transition()
    {
        if (this.element.hasAttribute('data-transition')) {
            return this.element.getAttribute('data-transition');
        }

        return null;
    }

    get loading()
    {
        if (this.element.hasAttribute('data-loading')) {
            return this.element.getAttribute('data-loading');
        }

        return null;
    }

    get loadingTemplate()
    {
        if (this.element.hasAttribute('data-loading-template')) {
            return this.element.getAttribute('data-loading-template');
        }

        return null;
    }

    get closeTemplate()
    {
        if (this.element.hasAttribute('data-close-template')) {
            return this.element.getAttribute('data-close-template');
        }

        return null;
    }
}
